<template>
    <div class="edit">
        <div class="tableTab">
            <div :class="tableIdx == index? 'tableItem se':'tableItem'" v-for="(item,index) in template" :key="item.id" @click="select(index)">
                <el-input  v-model="item.name" :placeholder="item.name" v-if="tableIdx == index"></el-input>
                <span v-else>{{item.name}}</span>
                <i class="el-icon-close" @click.stop="removeTemplate(index)" v-show="tableIdx !== index"></i>
            </div>
            <div :class="tableIdx == -11? 'tableItem se':'tableItem'"  @click="addTemplate()" v-if="template.length < 7">
                <el-input  v-model="newTable.name" :placeholder="newTable.name" v-if="tableIdx == -11"></el-input>
                <span v-else><i class="el-icon-plus"></i> {{newTable.name}}</span>
            </div>
            <div class="closeBtn" @click="saveClose">退出编辑</div>
        </div>
        <div class="tableHead">
            {{nowDate}}抄表单
            <div class="selectPicker">
                抄表频次: 
                <span @click="show = !show">{{meterFrequency}} <i class="el-icon-caret-bottom"></i>
                    <div class="fres" v-show="show">
                        <div :class="freIdx == index?'fre se':'fre'" v-for="(item,index) in fres" :key="item.id" @click="selectFre(index)">
                            {{item.fre}}
                        </div>
                    </div>
                </span>
            </div>
        </div>
        <div class="config">
            <div class="configHeader">
                <div class="title">表头内容</div>
                <div class="header">
                    <div class="headerBox">
                        <el-checkbox-group v-model="checkedConfigs" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="item in tableConfig" :label="item.label" :key="item.id">{{item.label}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="foot">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{!checkAll?'全选':'取消全选'}}</el-checkbox>
                </div>
            </div>
            <div class="configHeader">
                <div class="title">表计管理</div>
                <div class="meter">
                    <div :class="!selectAllMeter? 'meterTable':'meterTable meterTable1'">
                        <el-table
                            ref="multipleTable"
                            :data="meterManger"
                            tooltip-effect="dark"
                            style="width: 100%;height:100%;"
                            height="600"
                            @select="selectRow"
                            :row-style='rowClass'
                            @row-click="selectMeterOne"
                            @select-all="selectMeterAll"
                            @selection-change="handleSelectionChange">
                            <el-table-column
                            type="selection"
                            width="50">
                            </el-table-column>
                            <el-table-column
                            label="编号"
                            width="100">
                            <template slot-scope="scope">{{ scope.row.meterNo }}</template>
                            </el-table-column>
                            <el-table-column
                            prop="meterType"
                            label="类型"
                            width="70">
                            </el-table-column>
                            <el-table-column
                            prop="meterName"
                            label="名称"
                            show-overflow-tooltip>
                            <!-- <template slot-scope="scope">
                                <div class="warp" v-if="!scope.row.isInput">
                                    <div class="meterName">
                                        {{ scope.row.meterName }}
                                    </div>
                                    <div class="editBtn" @click="editMeter(scope.row)">
                                        <img src="../../../assets/img/edit_icon.png" alt="">
                                    </div>
                                </div>
                                <div class="editInput" v-if="scope.row.isInput">
                                    <div class="box">
                                        <el-input v-model="editMeterName" :placeholder="scope.row.meterName"></el-input>
                                        <div class="editBtn" @click="saveMeter(scope.row)">
                                            <img src="../../../assets/img/save_icon.png" alt="">
                                        </div>
                                    </div>
                                    
                                </div>
                            </template> -->
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="foot">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _setTemplateHeader, _setTemplateMeter, _addTemplate, _removeTemplate } from '../../../api/power'
export default {
    props:['templateList', 'currentTime', 'countWeek','tableConfig', 'meterList', 'idx'],
    data(){
        return {
            tableIdx:-1,
            editMeterName:'',
            show:false,
            freIdx:0,
            template:[],
            fres:[
                {
                    id:1,
                    fre:'一月一次'
                },
                {
                    id:2,
                    fre:'一周一次'
                },
                {
                    id:3,
                    fre:'一日一次'
                },
            ],
            newTable:{
                name:'新建模板'
            },
            checkAll: false,
            checkedConfigs: ['表号', '表名'],
            checkedMeters:[], // 当前选中的表计
            isIndeterminate: true,
            meterManger:[],
            // tableConfig:[
            //     {
            //         idx:1,
            //         label:'表号',
            //         prop:'meterNo'
            //     },
            //     {
            //         idx:2,
            //         label:'表名',
            //         prop:'meterName'
            //     },
            //     {
            //         idx:3,
            //         label:'表类型',
            //         prop:'meterType'
            //     },
            //     {
            //         idx:4,
            //         label:'上月用量',
            //         prop:'lastMonthElectric'
            //     },
            //     {
            //         idx:5,
            //         label:'本月用量',
            //         prop:'currentMonthElectric'
            //     },
            //     {
            //         idx:6,
            //         label:'同比增加/减少',
            //         prop:'incDec'
            //     },
            //     {
            //         idx:7,
            //         label:'本月起码',
            //         prop:'start'
            //     },
            //     {
            //         idx:8,
            //         label:'本月止码',
            //         prop:'end'
            //     },
            // ],
            // meterManger: [{
            //     meterNo: 'A1054850',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054851',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054852',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054853',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054854',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054855',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            //     }, {
            //     meterNo: 'A1054856',
            //     meterType: '电表',
            //     meterName: '办公楼一楼电表',
            //     isInput:false
            // }],
            multipleSelection: [],
            currentTable:{},
            meterFrequency:'',
        }
    },
    computed:{
        nowDate(){
            let time = this.currentTime.split('-')
            let now = ''
            switch(this.meterFrequency){
                case '一月一次':
                    now = `${time[0]}年${time[1]}月`
                    break;
                case '一周一次':
                    now = this.getWeek(this.countWeek)
                    break;
                case '一日一次':
                    now = `${time[0]}年${time[1]}月${time[2]}日`
                    break;
            }
            return now
        },
        selectAllMeter(){
            return this.multipleSelection.length == this.meterManger.length
        },
        
    },
    watch:{
        meterFrequency(val){
            // console.log(this.currentTime);
        },
        tableIdx(newval,oldval){
            let editTem = this.template[oldval]
            
            if(!editTem) return

            if(editTem.editHeader){
                // console.log('上一个修改表头');
                this.saveHeader(oldval)
            }
            if(editTem.editMeter){
                // console.log('上一个修改表计');
                this.saveMeterLoop(oldval)
            }

            this.updateTemplate(oldval)
        },
    },
    mounted(){
        let _this = this
        this.tableIdx = this.idx
        if(this.meterList){
            this.meterManger = this.meterList
        }
        if(this.templateList.length>0){
            this.template = this.templateList
            setTimeout(()=>{
                _this.select(this.tableIdx, 'start')
            }, 500)
        }
        
    },
    methods:{
        formatFre(cycle){
            switch(cycle){
                case 'month':
                    this.meterFrequency = '一月一次'
                    break;
                case 'week':
                    this.meterFrequency = '一周一次'
                    break;
                case 'day':
                    this.meterFrequency = '一日一次'
                    break;
            }
        },
        select(idx, remove){
            if(!remove){
                if(!this.template[this.tableIdx].tableConfig[0]){
                     this.template[this.tableIdx].tableConfig = []
                }
                if(this.template[this.tableIdx].loops.length < 1){
                    this.$message.error('表计管理至少勾选一个');
                    return
                }else if(this.template[this.tableIdx].tableConfig.length < 3 ){
                    this.$message.error('表头内容至少勾选三个');
                    return
                }
                if(this.template[this.tableIdx].name.length < 3 ){
                    this.$message.error('模板名称至少输入三个字符');
                    return
                }
            }
            

            let _this = this
            this.tableIdx = idx
            
            this.currentTable = this.template[idx]
            
            this.formatFre(this.currentTable.cycle)
            this.checkedConfigs = this.template[idx].tableConfig.map(item =>{
                return item = item.label
            })

            
            this.checkedMeters = this.currentTable.loops.map(item =>{
                let meter = this.meterManger.find(meter =>meter.meterNo == item)
                return item = meter
            })
            if(this.template[this.tableIdx].tableConfig.length = this.tableConfig.length){
                this.checkAll = true
            }

            
            _this.toggleSelection(this.checkedMeters)


            _this.template[idx].editHeader = false
            _this.template[idx].editMeter = false

            
            // console.log(this.currentTable);
            
            
        },
        toggleSelection(rows) {
            this.$refs.multipleTable.clearSelection();
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } 
            // else {
            //     this.$refs.multipleTable.clearSelection();
            // }
        },
        selectFre(idx){
            this.freIdx = idx
            
            this.meterFrequency = this.fres[idx].fre
            // console.log(this.meterFrequency);

            let cycle = ''
            switch(this.meterFrequency){
                case '一月一次':
                    cycle = 'month'
                    break;
                case '一周一次':
                    cycle = 'week'
                    break;
                case '一日一次':
                    cycle = 'day'
                    break;
            }
            this.template[this.tableIdx].cycle = cycle
            // this.$emit('selectFre', this.meterFrequency)
        },
        handleCheckAllChange(val) {
            // console.log(val);
            let arr = this.tableConfig.map(item =>{
                return item = item.label
            })
            this.checkedConfigs = val ? arr : [];
            this.isIndeterminate = false;
            
            // console.log(this.checkedConfigs);
            if(this.checkedConfigs.length > 0){
                let headers = this.checkedConfigs.map(item =>{
                    let head = this.tableConfig.find(con =>con.label == item)
                    return item = head
                })
                this.template[this.tableIdx].tableConfig = headers
            }else{
                this.template[this.tableIdx].tableConfig = []
            }

            this.template[this.tableIdx].editHeader = true

            // console.log('勾选表头有修改');
        },
        handleCheckedCitiesChange(value) {
            // console.log(value);
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.tableConfig.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableConfig.length;
            
            // this.template[this.tableIdx].tableConfig = value
            if(value.length > 0){
                let headers = value.map(item =>{
                    let head = this.tableConfig.find(con =>con.label == item)
                    return item = head
                })
                this.template[this.tableIdx].tableConfig = headers
            }else{
                this.template[this.tableIdx].tableConfig = []
            }

            this.template[this.tableIdx].editHeader = true

            // console.log('勾选表头有修改');
        },
        handleSelectionChange(val) {
            // console.log(val);
            this.multipleSelection = val;
        },
        selectMeterAll(rows){
            // console.log(rows);
            if(rows.length >0){
                let loops = rows.map(item =>{
                    return item = item.loopId
                })
                this.template[this.tableIdx].loops = loops
            }else{
                this.template[this.tableIdx].loops = []
            }
            
            
            this.template[this.tableIdx].editMeter = true

            // console.log('全选表头有修改');
        },
        selectMeterOne(row, cell, event){
            // console.log(row);
            
            if (row) {
                let one = this.multipleSelection.find(item =>item.loopId == row.loopId)
                // console.log(one);
                if(one){
                    this.$refs.multipleTable.toggleRowSelection(row,false);
                }else{
                    this.$refs.multipleTable.toggleRowSelection(row,true);
                }

                if(this.multipleSelection.length >0){
                    let loops = this.multipleSelection.map(item =>{
                        return item = item.loopId
                    })
                    this.template[this.tableIdx].loops = loops
                }else{
                    this.template[this.tableIdx].loops = []
                }
                this.template[this.tableIdx].editMeter = true
                // console.log(this.multipleSelection);
            } 
        },
        selectRow(rows, row){
            // console.log(rows, row);
            if(rows.length >0){
                let loops = rows.map(item =>{
                    return item = item.loopId
                })
                this.template[this.tableIdx].loops = loops
            }else{
                this.template[this.tableIdx].loops = []
            }
            
            
            this.template[this.tableIdx].editMeter = true

            // console.log('勾选表计有修改');
        },
        rowClass({row, rowIdx}){
            let selectStyle = {
                "color":'#0D94FF !important'
            }
            if(this.multipleSelection.findIndex(item =>item.meterNo == row.meterNo) !== -1){
                return selectStyle
            }
        },
        editMeter(row){
            // console.log(row);
            this.meterManger.forEach(item =>{
                if(item.meterNo == row.meterNo){
                    item.isInput = true
                }else{
                    item.isInput = false
                }
            })
        },
        saveMeter(row){
            // console.log(row);
            this.meterManger.forEach(item =>{
                if(item.meterNo == row.meterNo){
                    item.isInput = false
                    item.meterName = this.editMeterName
                    this.editMeterName = ''
                }else{
                    item.isInput = false
                }
            })
        },
        getWeek(val){
            // console.log(val);
            let firstDay = new Date(val.getFullYear(), 0, 1)  // 当前年份的第一天
            let dayOfWeek = firstDay.getDay()  // 当前年份的第一天是周几
            let spendDay = 1
            if(dayOfWeek !=0){
                spendDay = 7 -dayOfWeek + 1  // 距离下周还有几天
            }
            
            firstDay = new Date(val.getFullYear(), 0, 1 + spendDay)

            let d = Math.ceil((val.valueOf() - firstDay.valueOf()) / 86400000)
            
            let result = Math.ceil(d / 7)
            let year = val.getFullYear()
            let week = result 
            if(dayOfWeek !== 0){
                week = result + 1
            }
            if(week === 53 && val.getDate() !== 26){
                week = 1
                year += 1
            }
            if(week === 0){
                week = 52
                year -= 1
            }
            return `${year}年第${week}周`
        },
        saveClose(){
            let _this = this
            if(this.template[this.tableIdx].loops.length < 1){
                this.$message.error('表计管理至少勾选一个');
                return
            }else if(this.template[this.tableIdx].tableConfig.length < 3){
                this.$message.error('表头内容至少勾选三个');
                return
            }
            if(this.template[this.tableIdx].name.length < 3 ){
                this.$message.error('模板名称至少输入三个字符');
                return
            }
            if(this.template[this.tableIdx].editHeader && this.template[this.tableIdx].editMeter){
                

                this.saveHeader(this.tableIdx )
                setTimeout(()=>{
                    _this.saveMeterLoop(this.tableIdx, 'close')
                }, 200)
            }else if(this.template[this.tableIdx].editHeader){
                this.saveHeader(this.tableIdx, 'close')
            }else if(this.template[this.tableIdx].editMeter){
                this.saveMeterLoop(this.tableIdx, 'close')
            }else{
                this.$emit('close', this.tableIdx)
            }
            this.updateTemplate(this.tableIdx)
            
        },
        async saveHeader(idx, close){
            let _this = this
            
            // console.log(this.template[idx]);
            if(this.template[idx].tableConfig.length < 3){
                this.$message.error('表头内容至少勾选三个');
                return
            }

            let headers = this.template[idx].tableConfig.map(item =>item = item.idx).join(',')
            
            try{
                let res = await _setTemplateHeader({
                    headers,
                    templateId:this.template[idx].id
                })
                
                if(res.data.code == 200){
                    // console.log('表头保存成功');
                    if(close){
                        this.$emit('close', this.tableIdx, )
                    }
                }else{
                    // console.log(res.data.errMsg);
                }
                
            }catch(err){
                console.log(err);
            }
            
        },
        async saveMeterLoop(idx, close){
            if(this.template[idx].loops.length < 1){
                this.$message.error('表计管理至少勾选一个');
                return
            }
            let loopIds = this.template[idx].loops.length == 0?'': this.template[idx].loops.join(',')
            console.log(loopIds);
            try{
                let res = await _setTemplateMeter({
                    loopIds,
                    templateId:this.template[idx].id
                })

                if(res.data.code == 200){
                    console.log('表计保存成功');
                    if(close){
                        this.$emit('close', this.tableIdx)
                    }
                }else{
                    // console.log(res.data.errMsg);
                }
            }catch(err){
                console.log(err);
            }
        },
        addTemplate(){
            if(this.template.length>0){
                if(this.template[this.tableIdx].loops.length < 1){
                    this.$message.error('表计管理至少勾选一个');
                    return
                }else if(this.template[this.tableIdx].tableConfig.length < 3){
                    this.$message.error('表头内容至少勾选三个');
                    return
                }
                if(this.template[this.tableIdx].name.length < 3 ){
                    this.$message.error('模板名称至少输入三个字符');
                    return
                }
            }
            
            let template = {
                cycle:'month',
                tableConfig:[],
                id:this.template.length==0?100:this.template[this.template.length - 1].id + 100,
                loops:[],
                name:'新建模板',
                projectId:this.$store.getters.projectId,
                editHeader:false,
                editMeter:false,
            }
            
            this.template.push(template)
            this.addTemplateData(template)
            
            
        },
        async addTemplateData(newTemplate){
            console.log(newTemplate);
            try{

                let res = await _addTemplate({
                    name:newTemplate.name,
                    projectId:newTemplate.projectId,
                    type:newTemplate.cycle
                })
                if(res.data.code == 200){
                    console.log('新建模板成功');
                    this.template[this.template.length - 1].id = res.data.data.id
                    this.select(this.template.length - 1)
                }else{
                    // console.log(res.data.errMsg);
                }
                
            }catch(err){
                console.log(err);
            }
        },
        async removeTemplate(idx){

            let _this = this
            let template = this.template[idx]
            
            try{    
                let res = await _removeTemplate({
                    templateId:template.id
                })
                if(res.data.code == 200){
                    this.template.splice(idx, 1)
                    let index = this.template.findIndex(item =>item.id == this.currentTable.id) 
                    _this.select(index, 'remove')
                    console.log('删除成功');
                    
                }else{
                    console.log(res);
                }
            }catch(err){
                console.log(err);
            }
        },
        async updateTemplate(idx){
            let template = this.template[idx]
            
            try{
                let res = await _addTemplate({
                    name:template.name,
                    projectId:this.$store.getters.projectId,
                    type:template.cycle,
                    id:template.id
                })

                // console.log(res);
                if(res.data.code == 200){
                    console.log('更新模板成功');
                }else{
                    // console.log(res.data.errMsg);
                }
            }catch(err){
                console.log(err);
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .edit{
        .tableTab{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            position: relative;
            .tableItem{
                width: 152rem;
                height: 40rem;
                line-height: 40rem;
                background: #FFFFFF;
                border: 1px solid #999999;
                border-radius: 2px;
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                margin-right: 8rem;
                display: flex;
                // justify-content:center;
                padding-left: 15rem;
                align-items: center;
                position: relative;
                cursor: pointer;

                /deep/ .el-input__inner {
                    background: #FFFFFF;
                    border: 1px solid #CCCCCC;
                    border-radius: 2px;
                    height: 28rem;
                    width: 128rem;
                    border: none;
                    outline: none;
                    line-height: 28rem;
                    margin-left: 8rem;
                }

                .el-icon-close:before {
                    width: 14rem;
                    height: 14rem;
                    line-height: 14rem;
                    text-align: center;
                    border-radius: 50%;
                    background:#FD4238 ;
                    color: #fff;
                    position: absolute;
                    font-size: 12rem;
                    right: -7rem;
                    top: -7rem;
                }
            }
            .se{
                background: #0E9CFF;
                border: 1px solid #0E9CFF;
                color: #fff;
                padding-left: 0;
            }

            .closeBtn{
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(0, -45%);
                width: 100rem;
                height: 40rem;
                line-height: 40rem;
                text-align: center;
                background: #0D94FF;
                border-radius: 2px;
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
            }
        }
        .tableHead{
            height: 75rem;
            line-height: 75rem;
            text-align: center;
            font-size: 28rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #666666;
            position: relative;
            .selectPicker{
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(0, -50%);
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
                width:210rem ;
                display: flex;
                justify-content: space-between;
                align-items: center;
                z-index: 999;

                &>span{
                    display: inline-block;
                    width: 112rem;
                    height: 32rem;
                    display: flex;
                    align-items: center;
                    padding-left: 12rem;
                    background: #FFFFFF;
                    border: 1px solid #CCCCCC;
                    border-radius: 2px;
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    cursor: pointer;
                    position: relative;
                    &>i{
                        margin-left: 3rem;
                    }

                    .fres{
                        position: absolute;
                        top: 100%;
                        right: -1rem;
                        
                        background: #FFFFFF;
                        box-shadow: 0px 2px 10px 0px rgba(8,1,3,0.24);
                        border-radius: 2px;
                        .fre{
                            width: 111rem;
                            height: 32rem;
                            line-height: 32rem;
                            background: #FFFFFF;
                            text-align: left;
                            padding-left: 12rem;
                            border: 1px solid #CCCCCC;
                            border-top: none;
                            border-radius: 2px;
                            font-size: 18rem;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #333333;
                            cursor: pointer;
                            &:hover{
                                color: #0E9CFF;
                            }
                        }
                        .se{
                            color: #0E9CFF;
                        }
                    }
                }

                
            }
        }

        .config{
            height: 800rem;
            display: flex;
            justify-content: space-between;

            .configHeader{
                width: 30vw;
                height: 100%;
                background: #F1F1F1;
                border-radius: 2px;

                .title{
                    height: 50rem;
                    line-height: 50rem;
                    padding-left: 16rem;
                    border-bottom: 1px solid rgba(0,0,0,0.15);
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                }

                .header{
                    padding:14rem 16rem;
                    width: 100%;
                    height: 700rem;
                    .headerBox{
                        width: 100%;
                        height: 700rem;
                        .el-checkbox-group {
                            display: flex;
                            flex-direction: column;
                            /deep/.el-checkbox__label{
                                font-size: 18rem;
                            }
                            /deep/.el-checkbox{
                                padding-bottom: 14rem;
                            }
                        }
                    }

                }

                .meter{
                    width: 100%;
                    height: 700rem;
                    .meterTable{
                        width: 100%;
                        height: 700rem;
                        /deep/.el-table{
                            height: calc(100% - 6rem);
                        }
                        /deep/.el-table th{
                            background-color: #F1F1F1 !important;
                        }
                        /deep/.el-table td, .el-table th {
                            height: 40rem;
                            line-height: 40rem;
                        }
                        /deep/.el-table tr{
                            background-color: #F1F1F1 !important;
                        }
                        /deep/.el-table td, .el-table th.is-leaf {
                            border: none;
                        }
                        /deep/.el-table td:nth-child(3){
                            border-left: 1px dashed #CCCCCC;
                            border-right: 1px dashed #CCCCCC;
                        }
                        /deep/.el-table th:nth-child(3){
                            border-left: 1px dashed #CCCCCC;
                            border-right: 1px dashed #CCCCCC;
                        }
                        /deep/.el-table th.is-leaf {
                            border-bottom: 1px dashed #CCCCCC;
                        }
                        .el-table--border::after, .el-table--group::after, .el-table::before {
                            content: '';
                            position: absolute;
                            background-color:none; 
                            z-index: 1;
                        }
                        /deep/.el-table th>.cell {
                            position: relative;
                            .el-checkbox{
                                position: fixed;
                                top: 93.2%;
                                left: 37.5vw;
                                // z-index: 99;
                                width: 56rem;
                                height: 32rem;
                                text-align: center;
                                line-height: 32rem;
                                background: #0D94FF;
                                border-radius: 2px;
                                padding: 0 10rem;
                                &::before{
                                    content: '全选';
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    font-size: 18rem;
                                    font-family: Source Han Sans CN;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }

                                // &>.el-checkbox__input {
                                //     display: none;
                                // }
                            }
                        }
                        /deep/.el-table th > .cell .el-checkbox > .el-checkbox__input {
                            display: none;
                        }
                        /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
                            background-color: rgba(13,148,255,0.08);
                        }

                        .warp{
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20rem;
                            .editBtn{
                                width: 16rem;
                                height: 16rem;
                                cursor: pointer;
                                &>img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                        .editInput{
                            .box{
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding-right: 20rem;
                                width: 100%;
                                height:32rem ;
                                background: #FFFFFF;
                                border: 1px solid #CCCCCC;
                                border-radius: 2px;

                                /deep/ .el-input__inner {
                                    border: none;
                                    outline: none;
                                    height: 100%;
                                }

                                .editBtn{
                                    width: 16rem;
                                    height: 16rem;
                                    cursor: pointer;
                                    &>img{
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                    .meterTable1{
                        /deep/.el-table th>.cell {
                            .el-checkbox{
                                width: 88rem;
                                &::before{
                                    content: '取消全选';
                                }
                            }
                        }
                    }
                }
                .foot{
                    display: flex;
                    align-items:center ;
                    padding-left: 16rem;
                    height: 50rem;
                    
                    /deep/.el-checkbox__input{
                        display: none;
                    }
                    /deep/.el-checkbox__label{
                        // width: 56rem;
                        padding: 0 10rem;
                        height: 32rem;
                        text-align: center;
                        line-height: 32rem;
                        background: #0D94FF;
                        border-radius: 2px;
                        font-size: 18rem;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>